export default "__VITE_ASSET__U9AoDsoA__"